import { render, staticRenderFns } from "./TbOrderDetail.vue?vue&type=template&id=11e9d937&scoped=true&"
import script from "./TbOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TbOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e9d937",
  null
  
)

export default component.exports